import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import ScrollSmoother from 'gsap/ScrollSmoother';

gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother);

// Check if Tocbot is active
const isTableOfContents = document.querySelector('.table-of-contents');

let smoother;
if (!isTableOfContents) {
    smoother = ScrollSmoother.create({
        wrapper: "#smooth-wrapper",
        content: "#smooth-content",
        smooth: 0.2,
        effects: true,
    });
}

// Marquee animation
const marquee = document.querySelector('.marquee');

if (marquee) {
    const marqueeContainer = marquee.parentNode;
    const originalContent = marquee.innerHTML;

    const setupMarquee = () => {
        marquee.innerHTML = originalContent + originalContent;

        gsap.killTweensOf(marquee);

        const totalWidth = marquee.scrollWidth / 2;

        // 🔧 Adjust speed based on screen size
        let duration;
        const screenWidth = window.innerWidth;

        if (screenWidth >= 1200) {
            duration = 40; // big screen = slower scroll
        } else if (screenWidth >= 768) {
            duration = 30; // tablet-ish
        } else {
            duration = 20; // mobile = faster scroll
        }

        gsap.to(marquee, {
            x: `-=${totalWidth}`,
            duration: duration,
            repeat: -1,
            ease: 'none',
            modifiers: {
                x: gsap.utils.unitize(x => parseFloat(x) % totalWidth)
            }
        });
    };

    setupMarquee();
    window.addEventListener('resize', setupMarquee);
}

// Custom flair button
class Button {
    constructor(buttonElement) {
        this.block = buttonElement;
        this.init();
        this.initEvents();
    }

    init() {
        const el = gsap.utils.selector(this.block);

        this.DOM = {
            button: this.block,
            flair: el(".button__flair"),
        };

        this.xSet = gsap.quickSetter(this.DOM.flair, "xPercent");
        this.ySet = gsap.quickSetter(this.DOM.flair, "yPercent");
    }

    getXY(e) {
        const { left, top, width, height } = this.DOM.button.getBoundingClientRect();

        const xTransformer = gsap.utils.pipe(gsap.utils.mapRange(0, width, 0, 100), gsap.utils.clamp(0, 100));

        const yTransformer = gsap.utils.pipe(gsap.utils.mapRange(0, height, 0, 100), gsap.utils.clamp(0, 100));

        return {
            x: xTransformer(e.clientX - left),
            y: yTransformer(e.clientY - top),
        };
    }

    initEvents() {
        this.DOM.button.addEventListener("mouseenter", (e) => {
            const { x, y } = this.getXY(e);

            this.xSet(x);
            this.ySet(y);

            gsap.to(this.DOM.flair, {
                scale: 1,
                duration: 0.4,
                ease: "power2.out",
            });
        });

        this.DOM.button.addEventListener("mouseleave", (e) => {
            const { x, y } = this.getXY(e);

            gsap.killTweensOf(this.DOM.flair);

            gsap.to(this.DOM.flair, {
                xPercent: x > 90 ? x + 20 : x < 10 ? x - 20 : x,
                yPercent: y > 90 ? y + 20 : y < 10 ? y - 20 : y,
                scale: 0,
                duration: 0.3,
                ease: "power2.out",
            });
        });

        this.DOM.button.addEventListener("mousemove", (e) => {
            const { x, y } = this.getXY(e);

            gsap.to(this.DOM.flair, {
                xPercent: x,
                yPercent: y,
                duration: 0.4,
                ease: "power2",
            });
        });
    }
}

const buttonElements = document.querySelectorAll('[data-block="button"]');

buttonElements.forEach((buttonElement) => {
    new Button(buttonElement);
});

document.addEventListener("DOMContentLoaded", function () {
    let lastScrollTop = 0;
    const nav = document.querySelector(".menu-total-wrapp"); // Change to your actual nav class

    gsap.registerPlugin(ScrollTrigger);

    window.addEventListener("scroll", function () {
        let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScroll > lastScrollTop) {
            // Scrolling Down → Hide Nav
            gsap.to(nav, { y: "-100%", duration: 0.5, ease: "power2.out" });
        } else {
            // Scrolling Up → Show Nav
            gsap.to(nav, { y: "0%", duration: 0.5, ease: "power2.out" });
        }

        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll; // Ensure it doesn't go negative
    });
});